const aumDataAgainstSchemeReducer =(state=null, action)=>{
    switch(action.type){
      case "GET_AUM_DATA_AGAINST_SCHEME":
          return state;
      case "NULL_AUM_DATA_AGAINST_SCHEME" :
          return action.info;
      case "SET_AUM_DATA_AGAINST_SCHEME" :
          return action.info;
      default:
          return state;
    }
  }
  export default aumDataAgainstSchemeReducer